import React from "react";
import { SectionCta } from "../SectionCta";
import { images } from "../../data/content";
export function AuthorSection() {
  return <section className="bg-white px-5 py-16 sm:py-20" data-id="element-72" data-mp="3m6pi4awactsn">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-[0.85fr_1.15fr] md:gap-12" data-id="element-73" data-mp="3qygyxtpn3l5l">
        <div className="overflow-hidden rounded-3xl bg-mist" data-id="element-74" data-mp="3vyd2jrufdakm">
          <img src={images.author} alt="Dr. Valerica Montes in her dental clinic" className="aspect-[4/5] w-full object-cover object-top" data-id="element-75" data-mp="3vzxvxe506ngw" />
        </div>
        <div data-id="element-76" data-mp="33ahbp3rjecvr">
          <p className="text-[13px] font-extrabold uppercase tracking-[0.12em] text-brand-dark" data-id="element-77" data-mp="339y0e5we6mqp">Meet your author</p>
          <h2 className="mt-3 font-display text-[34px] font-black leading-tight text-navy-950" data-id="element-78" data-mp="38alrerkmf3kx">Dr. Valerica Montes</h2>
          <div className="mt-5 space-y-4 text-[17px] leading-relaxed text-muted" data-id="element-79" data-mp="nia6ykgl7ccn">
            <p data-id="element-80" data-mp="nke6yrbd7r7n">
              I believe that understanding the clinical principles behind professional whitening is essential for making thoughtful treatment
              decisions.
            </p>
            <p data-id="element-81" data-mp="2460nwl3jrsj2">
              Dental bleaching is not simply about selecting a product or following a standard procedure. Every patient presents different
              clinical considerations, aesthetic expectations, and potential limitations.
            </p>
            <p data-id="element-82" data-mp="1q7aj0jahkok5">
              With DENTAL BLEACHING BLUEPRINT™, my goal is to give you an organized educational resource that makes these important topics
              easier to study and review — from patient assessment and whitening techniques to bleaching agents, sensitivity management,
              challenging discoloration, and long-term maintenance.
            </p>
            <p data-id="element-83" data-mp="17idw50hf4yby">
              Whether you're expanding your knowledge or reviewing familiar concepts, I want this library to help you approach professional
              whitening with greater clarity.
            </p>
            <p className="font-display text-[19px] font-extrabold leading-snug text-navy-950" data-id="element-84" data-mp="xkppbc6jg0df">
              Because confident clinical decisions begin with understanding the science behind them.
            </p>
            <p className="font-semibold text-ink" data-id="element-85" data-mp="svx0k11bag4m">— Dr. Valerica Montes</p>
          </div>
        </div>
      </div>
      <div className="mx-auto max-w-5xl" data-id="element-86" data-mp="dzphx55jxmrg">
        <SectionCta label="Learn whitening with Dr. Montes" note="Start studying today — instant access" data-id="element-87" data-mp="iwpnleyhoni1" />
      </div>
    </section>;
}